import {
  CREATE_TOKEN_REQUEST,
  CREATE_TOKEN_SUCCESS,
  CREATE_TOKEN_FAILURE,
  LIST_TOKENS_REQUEST,
  LIST_TOKENS_SUCCESS,
  LIST_TOKENS_FAILURE,
  UPDATE_TOKEN_REQUEST,
  UPDATE_TOKEN_SUCCESS,
  UPDATE_TOKEN_FAILURE,
  REVOKE_TOKEN_REQUEST,
  REVOKE_TOKEN_SUCCESS,
  REVOKE_TOKEN_FAILURE,
  REGENERATE_TOKEN_REQUEST,
  REGENERATE_TOKEN_SUCCESS,
  REGENERATE_TOKEN_FAILURE,
  CLEAR_REVEALED_TOKEN,
  CLEAR_TOKENS_ERROR
} from '../../actions/auth/apiTokens';

const initialState = {
  tokens: [],
  isLoading: false,
  hasLoaded: false,
  error: null,
  // One-time plaintext token payload from create/regenerate. Cleared with
  // CLEAR_REVEALED_TOKEN once the user dismisses the reveal dialog.
  revealedToken: null,
  isCreating: false,
  isUpdating: false,
  isRevoking: false,
  isRegenerating: false
};

// Strip the one-time plaintext before storing the row in the list.
const toRow = (payload) => {
  const { token, message, ...row } = payload || {};
  return row;
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    // Create Token
    case CREATE_TOKEN_REQUEST:
      return {
        ...state,
        isCreating: true,
        error: null,
        revealedToken: null
      };
    case CREATE_TOKEN_SUCCESS:
      return {
        ...state,
        isCreating: false,
        revealedToken: action.payload,
        tokens: [toRow(action.payload), ...state.tokens],
        error: null
      };
    case CREATE_TOKEN_FAILURE:
      return {
        ...state,
        isCreating: false,
        error: action.payload,
        revealedToken: null
      };

    // List Tokens
    case LIST_TOKENS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case LIST_TOKENS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasLoaded: true,
        // Defensive: older backend versions include revoked tokens in the list
        tokens: (action.payload.tokens || []).filter((t) => t.is_active !== false),
        error: null
      };
    case LIST_TOKENS_FAILURE:
      return {
        ...state,
        isLoading: false,
        hasLoaded: true,
        error: action.payload
      };

    // Update (edit) Token
    case UPDATE_TOKEN_REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null
      };
    case UPDATE_TOKEN_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        tokens: state.tokens.map(token =>
          token.token_id === action.payload.token_id
            ? { ...token, ...toRow(action.payload) }
            : token
        ),
        error: null
      };
    case UPDATE_TOKEN_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload
      };

    // Revoke Token
    case REVOKE_TOKEN_REQUEST:
      return {
        ...state,
        isRevoking: true,
        error: null
      };
    case REVOKE_TOKEN_SUCCESS:
      return {
        ...state,
        isRevoking: false,
        tokens: state.tokens.filter(token => token.token_id !== action.payload.token_id),
        error: null
      };
    case REVOKE_TOKEN_FAILURE:
      return {
        ...state,
        isRevoking: false,
        error: action.payload
      };

    // Regenerate Token (token_id is stable; the row's metadata changes)
    case REGENERATE_TOKEN_REQUEST:
      return {
        ...state,
        isRegenerating: true,
        error: null,
        revealedToken: null
      };
    case REGENERATE_TOKEN_SUCCESS:
      return {
        ...state,
        isRegenerating: false,
        revealedToken: action.payload,
        tokens: state.tokens.map(token =>
          token.token_id === action.payload.token_id
            ? { ...token, ...toRow(action.payload) }
            : token
        ),
        error: null
      };
    case REGENERATE_TOKEN_FAILURE:
      return {
        ...state,
        isRegenerating: false,
        error: action.payload
      };

    case CLEAR_REVEALED_TOKEN:
      return {
        ...state,
        revealedToken: null
      };

    case CLEAR_TOKENS_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};
